import { openDB } from 'idb'

import type { HistoryItemType } from '@/types/xwan-swap-type'

const dbPromise = openDB('XStake', 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains('wrap')) {
      db.createObjectStore('wrap', {
        keyPath: 'startTime',
        autoIncrement: true,
      }).createIndex('user', 'user')
    }
    // if (!db.objectStoreNames.contains("unwrap")) {
    //   db.createObjectStore("unwrap", {
    //     keyPath: "startTime",
    //     autoIncrement: true,
    //   }).createIndex("user", "user");
    // }
  },
})

const getStore = async (scammerName: string) => {
  const db = await dbPromise
  const tx = db.transaction(scammerName, 'readwrite')
  const store = tx.objectStore(scammerName)
  return store
}

export const add = async (scammerName: string, value: HistoryItemType) => {
  const store = await getStore(scammerName)
  const res = await store.get(value.startTime)
  if (!res) {
    const result = await store.add(value)
    return result
  } else {
    console.log('%s key: %s already exists', scammerName, value.startTime)
    const result = await store.put(value)
    return result
  }
}

export const addAll = async (
  scammerName: string,
  arr: Array<HistoryItemType>,
) => {
  const store = await getStore(scammerName)
  const addList = arr.map(async (v: HistoryItemType) => {
    const res = await store.get(v.startTime)
    if (!res) {
      const result = await store.add(v)
      return result
    } else {
      console.log('%s key: %s already exists', scammerName, v.startTime)
      const result = await store.put(v)
      return result
    }
  })
  const list = await Promise.all(addList)
  return list
}

export const get = async (scammerName: string, key: string) => {
  const store = await getStore(scammerName)
  const value = await store.get(key)
  return value
}

export const getAllByKey = async (
  scammerName: string,
  index: string,
  key: string,
) => {
  const db = await dbPromise
  const data: Array<HistoryItemType | never> = await db.getAllFromIndex(
    scammerName,
    index,
    key && IDBKeyRange.only(key),
  )
  return data
}

export const set = async (scammerName: string, val: HistoryItemType) => {
  const store = await getStore(scammerName)
  const value = await store.put(val)
  return value
}
